/*
 * @Author: gujianghua
 * @Date:   2018-07-12 12:47:38
 * @Last Modified by:   gujianghua
 * @Last Modified time: 2020-05-14 15:59:22
 */
import { service } from '@/utils/request'
/**
 * 静态url
 * [baseUrl 公共域名]
 * @type {[obj]}
 */
export default {
  updatePhone: function updatePhone(path, params) {
    return service({
      url: '/cloud/uac/doctorManager/doctor/updatePhone/' + path,
      method: 'post',
      params: params
    })
  },
  // 医生
  selectDoctor(params) {
    return service({
      url: '/cloud/uac/v1/users/doctors/search',
      method: 'get',
      params: params
    })
  },
  // 小助手
  selectAssiant(path, data) {
    return service({
      url: '/cloud/uac/v1/admin/account/list' + path,
      method: 'post',
      data: data
    })
  },
  // 课程源
  courseOrgin(data) {
    return service({
      url: '/cloud/course/v1/admin/coursesource/pageList',
      method: 'post',
      data: data
    })
  },
  // 课程列表
  getCourseList(data) {
    return service({
      url: '/cloud/course/v1/admin/course/pageList',
      method: 'post',
      data: data
    })
  },
  // 帖子
  getNotesList(data) {
    return service({
      url: '/cloud/dvoice/v1/post/postListByPage',
      method: 'get',
      params: data
    })
  },
  // 帖子选择栏目
  getColumnList() {
    return service({
      url: '/cloud/dvoice/v1/column/all',
      method: 'get'
    })
  },
  // 名医列表
  famousDocList(data) {
    return service({
      url: '/cloud/dvoice/v1/doconline/getDocOnlineList',
      method: 'get',
      params: data
    })
  },
  // 医生列表
  docList(params) {
    return service({
      url: '/cloud/uac/v1/users/doctors/search',
      method: 'get',
      params: params
    })
  },
  //列表
  getEnterpriseList(page, params) {
    return service({
      url: '/cloud/uac/enterprise/pages?pageIndex=' + page.pageIndex + '&pageSize=' + page.pageSize,
      method: 'post',
      data: params
    })
  },
  // 有赞会员卡
  youzanVip(params) {
    return service({
      url: '/cloud/uac/v1/youzan/card/cardList',
      method: 'get',
      params: params
    })
  },
  // 限时促销
  limitSale(params) {
    return service({
      url: '/cloud/activity/v1/marketing/admin/course/list',
      method: 'get',
      params: params
    })
  },
  //获取列表
  getClassTypeList: (data) => {
    return service({
      url: '/cloud/course/v1/admin/course/product/type/list',
      method: 'get',
      params: data
    })
  },
  //获取列表
  getSubjectList: (data) => {
    return service({
      url: '/cloud/course/v1/admin/features/findList',
      method: 'get',
      params: data
    })
  },
	// 指南列表
	getGuideList(data) {
		return service({
			url: '/cloud/course/v1/admin/guide/search',
			method: 'post',
			data
		})
	},
  // 获取病例列表
  getIlnessList(params) {
    return service({
      url: "/cloud/course/v1/illness/case/list",
      method: "get",
      params
    });
  }
}



// WEBPACK FOOTER //
// ./src/api/selectSource/index.js